export const COSTE_DE_SERVICIO = 0.15

export const IVA = 1.21

export const COSTE_DE_SERVICIO_CON_IVA = COSTE_DE_SERVICIO * IVA
